import { useEffect, useRef } from 'react';

import useEventTracking from 'modules/common/components/AnalyticsTracking/useEventTracking';

const TARGET_WIDGET = 'w/modal-social-share-full-width';

export default function useImpactEmbedTracking(source: string, enabled = true) {
    const { sendTrackingEvent } = useEventTracking();
    const hasFiredRef = useRef(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const handleBlur = () => {
            if (hasFiredRef.current) {
                return;
            }

            if (timeoutRef.current != null) {
                clearTimeout(timeoutRef.current);
            }

            timeoutRef.current = setTimeout(() => {
                const { activeElement } = document;
                if (!activeElement || activeElement.tagName.toUpperCase() !== 'IMPACT-EMBED') {
                    return;
                }

                const widgetName = activeElement.getAttribute('widget');
                if (widgetName !== TARGET_WIDGET) {
                    return;
                }

                hasFiredRef.current = true;
                sendTrackingEvent('Referral Widget Interaction', {
                    category: 'Referral Widget',
                    action: 'widget_clicked',
                    widget_name: widgetName,
                    source,
                    location: window.location.pathname,
                });

                timeoutRef.current = null;
            }, 0);
        };

        window.addEventListener('blur', handleBlur);

        return () => {
            window.removeEventListener('blur', handleBlur);
            if (timeoutRef.current != null) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [sendTrackingEvent, source, enabled]);
}
